<template lang="pug">
.v-field-work-schedule.field-work-schedule(:class="{'field-range--sm': field.size === 'sm'}")
	label.field-label(v-if="field.label")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	.field-work-schedule__cells(v-for="(value, key, index) in field.items" :key="index" )
		.field-label {{ value.text }}
		.field-work-schedule__cell
			v-field-range(:field="{...value.work, disabled: isDayOff[key]}" :model-value="localValue[key].work" @update:model-value="handleInputWork(key, $event)")
			v-field-range(:field="{...value.break, disabled: isDayOff[key]}" :model-value="localValue[key].break" @update:model-value="handleInputBreak(key, $event)")
		.field-work-schedule__cell
			v-field-checkbox(
				:true-value="field.value[key].dayOff"
				:text="field.dayOff"
				:disabled="field.disabled"
				:model-value="localValue[key].dayOff"
				@update:model-value="setDayOff(key, $event)")
</template>

<script>
export default {
	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: Object,
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
			isDayOff: {}
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
			for (const key in this.localValue) {
				this.isDayOff = {...this.isDayOff, [key]: this.localValue[key]?.dayOff || false}
			}
		},

		setDayOff(key, e) {
			this.localValue[key].dayOff = e
			this.isDayOff[key] = e
			this.$emit('update:model-value', this.localValue);
		},

		handleInputWork(key, e) {
			this.localValue[key].work = e
			this.$emit('update:model-value', this.localValue);
		},

		handleInputBreak(key, e) {
			this.localValue[key].break = e
			this.$emit('update:model-value', this.localValue);
		},

	}
};
</script>
